import { parseNameAddrDisplayName } from './parse-name-addr-display-name'

export type CallEndedOriginator = 'local' | 'remote' | 'system'

export type CallEndedMessage = {
  getHeader?: (name: string) => string | undefined
}

export type CallEndedEventLike = {
  originator: CallEndedOriginator
  message?: CallEndedMessage
}

export const getCallEndedDialogProps = (
  e: CallEndedEventLike,
  t: (key: string, params?: Record<string, string>) => string,
): { information: string, description?: string } => {
  const information = t('common.callEnded')

  if (e.originator !== 'remote') {
    return { information }
  }

  const header = e.message?.getHeader?.('X-RTU-TERMINATED-BY')
  const name = header ? parseNameAddrDisplayName(header) : undefined

  return name
    ? { information, description: t('common.callEndedByParticipant', { name }) }
    : { information }
}
